import { proxy } from 'valtio';

import { isBoardReadOnly } from '@canvas/abilities/v1/permissions';
import { isEmbeddedSmartLink } from '@canvas/frame-api/host-api/host-frame-context';
import {
  CanvasToolPickEvent,
  type ToolCursorOverride,
  type ToolName,
} from '@canvas/model/ui';

/**
 * Non embedded tools are allowed to select as of https://product-fabric.atlassian.net/browse/CNS-7937
 */
export const READONLY_NON_EMBEDDED_TOOLS: ToolName[] = ['hand', 'select', 'comment'];

/**
 * Embedded isn't allowed to do anything other than pan around
 */
export const EMBEDDED_TOOLS: ToolName[] = ['hand'];

/**
 * Cursor-like tools that allow for minimisation of the toolbar
 */
export const CURSOR_LIKE_TOOLS: ToolName[] = ['select', 'hand', 'comment'];

export const defaultSelectedTool = isEmbeddedSmartLink() ? 'hand' : 'select';
export const defaultCursorOverride = null;

export const currentSelectedTool: {
  tool: ToolName;
  cursorOverride: ToolCursorOverride | null;
} = proxy({
  tool: defaultSelectedTool,
  cursorOverride: defaultCursorOverride,
});

export const isToolAllowed = (tool: ToolName): boolean => {
  if (isEmbeddedSmartLink()) {
    return EMBEDDED_TOOLS.includes(tool);
  }

  if (isBoardReadOnly()) {
    return READONLY_NON_EMBEDDED_TOOLS.includes(tool);
  }

  // Just your typical board: Everything is allowed
  return true;
};

export const updateSelectedTool = (t: ToolName) => {
  // Don't update selected tool to anything other than hand if read only outside
  // of embedded
  if (!isToolAllowed(t)) {
    return;
  }

  document.body.dispatchEvent(new CanvasToolPickEvent({ type: t }));
};
